import type NonEmptyText from '../non-empty-text';
import type Store from './store';
import { assertIsInstanceOfNonEmptyText, assertIsInstanceOfStore } from '../assertions';

interface ICurrency {
	readonly key: NonEmptyText;
	readonly store: Store;
}

export default class Currency implements ICurrency {
	public get key(): NonEmptyText {
		return this.#key;
	}

	public get store(): Store {
		return this.#store;
	}

	#key: NonEmptyText;
	#store: Store;
	public constructor({ key, store }: ICurrency) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
		assertIsInstanceOfStore(store);
		this.#store = store;
	}
}
